export default function Footer() {
    const year = new Date().getFullYear();
    return <footer>&copy; Jarek Skurzyński, {year}</footer>;
}
